<template>
  <div class="background-container">
    <div class="default-container">
      <div class="simple-header">
        <i @click="handlerClickBackButton"></i>
        <span>홈핏 추천</span>
        <span class="home" @click="handlerClickHomeButton">홈으로</span>
      </div>
      <div class="event__container">
        <div class="event__wrap">
          <div class="event__title__container">
            <p class="event__title">
              친구 초대하면? 친구도 나도 함께 받는 혜택!
            </p>
            <p class="event__subtitle">
              [이벤트] 친구 초대하면 백화점 상품권(3만원권) 또는 수업 1회 추가! 초대받은 친구는 5,000원 할인
            </p>
          </div>
          <div class="event__img__container">
            <img
              class="event__img__01"
              src="https://dcse8twossp9.cloudfront.net/static/img/event/recommend-contents-250526.png"
            />
          </div>
        </div>
        <div class="event__footer">
          <div class="footer__wrap">
            <div class="footer__btn btn--create" @click="createRecommendLink">
              <span>나만의 추천 코드 만들기</span>
            </div>
            <div class="footer__btn btn--inquiry" @click="channelIo.open()">
              <i />
              <span>문의</span>
            </div>
          </div>
        </div>
        <Modal
          v-if="isModalShow"
          modal-id="link-create"
          :recommendedEvent="true"
          @click-backdrop="isModalShow = false"
        >
          <slot name="link-create-success">
            <div class="create__top">
              <img
                class="create__bg"
                :class="{ animate: isModalShow }"
                src="https://dcse8twossp9.cloudfront.net/static/img/event/paper-boom@3x.png"
              />
              <div class="top__wrap">
                <p class="create__title">
                  <span>{{ name }}님 추천 코드</span>
                  <span>만들기 성공 &#x1F389;</span>
                </p>
                <div class="create__btn btn--view" @click="copyCode">
                  <span
                    >내 추천 코드 <b>{{ myRecommendCode }}</b>
                    <small>복사</small></span
                  >
                </div>
              </div>
            </div>
            <div class="create__bottom">
              <div class="bottom__wrap">
                <p class="bottom__title"><span>공유하기</span></p>
                <div class="share__container">
                  <div class="share__item" @click="copyLink">
                    <div class="share__icon link">
                      <i />
                    </div>
                    <span class="share__title">
                      링크복사
                    </span>
                  </div>
                  <div class="share__item" @click="shareKakao">
                    <div class="share__icon kakao">
                      <i />
                    </div>
                    <span class="share__title">
                      카카오톡
                    </span>
                  </div>
                  <div class="share__item" @click="shareMessage">
                    <div class="share__icon message">
                      <i />
                    </div>
                    <span class="share__title">
                      Message
                    </span>
                  </div>
                  <div class="share__item" @click="navigatorShare">
                    <div class="share__icon more">
                      <i />
                    </div>
                    <span class="share__title">
                      더보기
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </slot>
        </Modal>
      </div>
    </div>
  </div>
</template>
<script>
import Modal from '@/components/event/RecommendedModal'
import axios from 'axios'
import qs from 'qs'
import channelIo from '@/assets/js/channelIo'

export default {
  name: 'RecommendedEvent',
  data() {
    return {
      isModalShow: false,
      name: window.homefit.user.name,
      link: '',
      myRecommendCode: '',
      fetchedEncryptedRecommender: '',
      channelIo
    }
  },
  components: {
    Modal
  },
  created() {
    this.fetchEncryptedRecommender()
  },
  mounted() {
    document.querySelector('.hf_layout_header_uikit_wrap').style.display =
      'none'
  },
  methods: {
    async fetchEncryptedRecommender() {
      const response = await axios.post('/api/recommend/encryptedRecommender/')
      this.fetchedEncryptedRecommender = response.data.encryptedRecommender
      this.myRecommendCode = response.data.recommendCode
    },
    createRecommendLink: function() {
      if (!this.fetchedEncryptedRecommender) {
        if (window.homefit.user.isLoggedIn === false) {
          axios
            .post(
              '/api/session/redirect/',
              qs.stringify({ redirectTo: '/event/recommend/' })
            )
            .then(() => {
              location.href = '/user/login/'
            })
        } else {
          alert('추천 코드 만들기가 실패 했습니다. 다시 시도 해주세요.')
        }
        return
      }
      this.link = `${window.location.origin}/?recommender=${this.fetchedEncryptedRecommender}`
      this.isModalShow = true
    },
    copyCode: function() {
      let dummy = document.createElement('textarea')
      document.body.appendChild(dummy)
      dummy.value = this.myRecommendCode
      dummy.select()
      document.execCommand('copy')
      document.body.removeChild(dummy)

      alert('코드가 복사되었습니다.')
    },
    copyLink: function() {
      let dummy = document.createElement('textarea')
      document.body.appendChild(dummy)
      dummy.value = this.link
      dummy.select()
      document.execCommand('copy')
      document.body.removeChild(dummy)

      alert('링크가 복사되었습니다.')
    },
    shareKakao: function() {
      /* eslint-disable */

      if (!window.Kakao.isInitialized()) {
        window.Kakao.init(window.homefit.kakaoJavascriptApiKey)
      }
      window.Kakao.Link.sendDefault({
        objectType: 'feed',
        content: {
          title: '홈핏 초대장이 도착했어요.',
          description: '지금 초대 수락하면 5,000원 추가 할인!',
          imageUrl:
            'https://dcse8twossp9.cloudfront.net/static/img/event/%E1%84%8E%E1%85%B5%E1%86%AB%E1%84%80%E1%85%AE%E1%84%8E%E1%85%A9%E1%84%83%E1%85%A2%E1%84%8B%E1%85%B5%E1%84%87%E1%85%A6%E1%86%AB%E1%84%90%E1%85%B3_%E1%84%8F%E1%85%A1%E1%84%90%E1%85%A9%E1%86%A8%E1%84%8B%E1%85%AD%E1%86%BC.jpg',
          link: {
            mobileWebUrl: this.link,
            webUrl: this.link
          }
        },
        buttonTitle: '초대수락하기'
      })
      /* eslint-enable */
    },
    shareMessage: function() {
      if (window.homefit.isMobile) {
        const ua = navigator.userAgent.toLowerCase()
        if (
          ua.indexOf('iphone') > -1 ||
          ua.indexOf('ipad') > -1 ||
          ua.indexOf('ipod') > -1
        ) {
          location.href = `sms:&body=${this.link}`
        } else {
          location.href = `sms:?body=${this.link}`
        }
      } else {
        alert('지원하지 않는 브라우저입니다.')
        return false
      }
    },
    navigatorShare: function() {
      if (navigator.share === undefined) {
        alert('지원하지 않는 브라우저입니다.')
        return false
      }
      navigator.share({
        title: '홈핏',
        text: '찾아가는 전문 코치',
        url: this.link
      })
    },
    handlerClickBackButton() {
      if (window.opener) {
        this.handlerClickHomeButton()
      } else {
        history.go(-1)
      }
    },
    handlerClickHomeButton() {
      location.href = '/'
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/scss/_index.scss';
.background-container {
  background-color: #f8f8f8;
}
.simple-header {
  width: 100%;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: sticky;
  top: 0;
  background-color: #ffffff;
  z-index: 99;
}
.simple-header i {
  display: block;
  width: 24px;
  height: 24px;
  cursor: pointer;
  background: url(https://dcse8twossp9.cloudfront.net/static/img/v2/icon/arrow-back-black.svg)
    no-repeat center/cover;
  position: absolute;
  top: 50%;
  left: 24px;
  transform: translateY(-50%);
}
.simple-header span {
  font-size: 16px;
  font-weight: 500;
  text-align: center;
}
.simple-header span.home {
  display: inline-block;
  font-size: 14px;
  line-height: 18px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 24px;
  cursor: pointer;
  font-weight: 400;
}
.default-container {
  width: 100%;
  max-width: 648px;
  min-height: calc(100vh);
  min-height: calc(var(--vh, 1vh) * 100);
  margin: 0 auto;
  background-color: #ffffff;
}
.event__container {
  .event__wrap {
    width: 100%;
    margin: 0 auto;
    padding-bottom: 80px;
    .event__title__container {
      padding: 24px 24px 48px;
      .event__title {
        font-size: 24px;
        font-weight: $medium;
      }
      .event__subtitle {
        font-size: 16px;
        margin-top: 8px;
        word-break: keep-all;
      }
    }
    .event__img__container {
      img {
        margin-top: 24px;
      }
    }
  }
  .event__footer {
    width: 100vw;
    height: 80px;
    display: flex;
    align-items: center;
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: #e1e1eb;
    .footer__wrap {
      width: 640px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      .footer__btn {
        height: 56px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 8px;
        cursor: pointer;
        span {
          font-size: 18px;
          font-weight: 600;
        }
        &.btn--create {
          flex: 1;
          background-color: $btn-purple;
          span {
            color: #ffffff;
          }
        }
        &.btn--inquiry {
          width: 120px;
          margin-left: 12px;
          background-color: #ffffff;
          i {
            width: 34px;
            height: 34px;
            background-image: url(https://dcse8twossp9.cloudfront.net/static/img/event/face-bubble.svg);
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            margin-right: 8px;
          }
        }
      }
    }
  }
  .create__top {
    width: 100%;
    position: relative;
    &::after {
      content: '';
      display: block;
      padding-bottom: 100%;
    }
    .create__bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      animation-name: boom;
      animation-duration: 0.5s;
    }
    .top__wrap {
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .create__title {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-bottom: 12px;
        span {
          font-size: 30px;
          font-weight: $bold;
        }
      }
      .create__btn {
        width: 240px;
        height: 56px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 28px;
        background-color: black;
        cursor: pointer;
        i {
          width: 24px;
          height: 24px;
          background-image: url(https://dcse8twossp9.cloudfront.net/static/img/event/open-in-new-black-24-dp.svg);
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          margin-right: 8px;
        }
        span {
          display: table;
          font-size: 20px;
          color: #ffffff;
          b {
            color: #ffc800;
          }
          small {
            display: table-cell;
            vertical-align: middle;
            padding-left: 12px;
            font-size: 14px;
            opacity: 0.6;
          }
        }
      }
    }
  }
  .create__bottom {
    height: 188px;
    padding: 24px;
    .bottom__wrap {
      .bottom__title {
        text-align: center;
        padding-bottom: 12px;
        span {
          font-size: 16px;
          font-weight: $medium;
        }
      }
      .share__container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .share__item {
          display: flex;
          flex-direction: column;
          align-items: center;
          cursor: pointer;
          .share__icon {
            width: 64px;
            height: 64px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            margin-bottom: 7px;
            i {
              width: 32px;
              height: 32px;
              background-size: cover;
              background-position: center;
              background-repeat: no-repeat;
            }
            &.link {
              background-color: #e1e1eb;
              i {
                background-image: url(https://dcse8twossp9.cloudfront.net/static/img/event/content-copy-black-32-dp.svg);
              }
            }
            &.kakao {
              background-color: #fae100;
              i {
                width: 36px;
                background-image: url(https://dcse8twossp9.cloudfront.net/static/img/event/katalk.svg);
              }
            }
            &.message {
              background-color: #00c800;
              i {
                background-image: url(https://dcse8twossp9.cloudfront.net/static/img/event/mail-outline-black-32-dp.svg);
              }
            }
            &.more {
              background-color: #e1e1eb;
              i {
                background-image: url(https://dcse8twossp9.cloudfront.net/static/img/event/more-horiz-black-32-dp.svg);
              }
            }
          }
          span {
            font-size: 12px;
          }
        }
      }
    }
  }
}

@media all and (max-width: 648px) {
  .event__container {
    .event__wrap {
      width: 100%;
      padding: 0px 0 56px;
    }
    .create__top {
      .create__bg {
        animation-delay: 0.2s;
      }
    }
    .event__footer {
      height: 58px;
      background-color: $btn-purple;
      .footer__wrap {
        height: 100%;
        span {
          font-size: 16px;
        }
        .footer__btn {
          &.btn--inquiry {
            margin-left: 0;
            background-color: $btn-purple;
            position: relative;
            span {
              color: #ffffff;
            }
            i {
              background-image: url(https://dcse8twossp9.cloudfront.net/static/img/event/face-bubble-white.svg);
            }
            &::before {
              content: '';
              display: inline-block;
              width: 1px;
              height: 34px;
              background-color: #320064;
              position: absolute;
              left: 0;
            }
          }
        }
      }
    }
  }
}

@keyframes boom {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
